"use strict";
// @ts-ignore
try {
    self['workbox:strategies:6.5.3'] && _();
}
catch (e) { }
